import React from "react";
import { useEffect,useState } from "react";
import Extra from "./Extra";


const Movie=()=>{
const [users, setUsers]=useState([]);
const[use, setU]= useState(users);


 const url ="https://movie-task.vercel.app/api/popular?page=1";
 

const header=(e)=>{
console.log(e.target.value);
 setU(e.target.value);
}
 
const getData=async()=>{     
     const response=  await fetch(url);
     const movies = await response.json();
     console.log(movies.data.results);
     setUsers(movies.data.results);
    
}

useEffect(()=>{
    getData();
},[]);

    return(
<> 

<div className="App login-component">
      <h1 className="heading_style">List Of Popular Movies</h1>
      <div class="typewriter heading">
  <h1>Click on the card for movie info.</h1>
</div>
      <form action="form">
      <input type="text" placeholder="Type something.." onChange={header} className="input"/>
    <select name="countryCode"  id="codes" onChange={header} className="select">
<option value="">select</option>
<option value="2013">2013</option>
<option value="2015">2015</option>
<option value="2018">2018</option>
<option value="2020">2020</option>
<option value="2021">2021</option>
<option value="2022">2022</option>
<option value="2023">2023</option>
    </select>
      </form>

      <div className="popular-movies">
        {users.map((movie) => {  
            console.log(movie); 
if (movie.title.toLowerCase().includes(use) || (movie.title.toUpperCase().includes(use) ) || (movie.title.includes(use) ))
   return <Extra key={movie.id} movie={movie}/> 

else if(movie.release_date.includes(use))
    return <Extra key={movie.id} movie={movie}/>
   
        } )
        }
        
      </div> 
    </div>

</>
    )
}

export default Movie;